import { createHttpClient } from "./http";

class WhatsappRepository {
	constructor() {
		this.axios = createHttpClient({ timeout: 30000 });
	}

	getAuthHeader() {
		const token = localStorage.getItem("access_token");
		return { Authorization: `Bearer ${token}` };
	}

	async getMensagens(unidadeDistribuidoraId, page = 1, limit = 50) {
		return this.axios.get("whatsapp-distribuidor/mensagens", {
			params: { unidadeDistribuidoraId, page, limit },
			headers: this.getAuthHeader(),
		});
	}

	// dia: YYYY-MM-DD dos numeros; omitido = hoje.
	async getEstatisticas(unidadeDistribuidoraId, dia) {
		return this.axios.get("whatsapp-distribuidor/estatisticas", {
			params: { unidadeDistribuidoraId, ...(dia ? { dia } : {}) },
			headers: this.getAuthHeader(),
		});
	}

	// fornecedorIds vale so para este envio e nao altera a agenda salva. Omitir o
	// campo (undefined) faz o backend herdar a selecao da configuracao.
	// cultivoIds: culturas perguntadas ([] = todas). So recebe quem fornece todas.
	// horaLimiteRetificacao: "HH:mm" (horario de Brasilia) em que o prazo fecha.
	async enviarMensagens(unidadeDistribuidoraId, dataAlvo, fornecedorIds, dataLimiteRetificacao, cultivoIds = [], horaLimiteRetificacao) {
		return this.axios.post("whatsapp-distribuidor/enviar", { unidadeDistribuidoraId, dataAlvo, fornecedorIds, dataLimiteRetificacao: dataLimiteRetificacao || null, cultivoIds, horaLimiteRetificacao }, {
			headers: this.getAuthHeader(),
		});
	}

	// Culturas que podem ser pedidas, cada uma com os ids de quem a fornece.
	async listarCulturas(unidadeDistribuidoraId) {
		return this.axios.get("whatsapp-distribuidor/culturas", {
			params: { unidadeDistribuidoraId },
			headers: this.getAuthHeader(),
		});
	}

	async reenviarMensagem(id) {
		return this.axios.put(`whatsapp-distribuidor/mensagem/${id}/reenviar`, {}, {
			headers: this.getAuthHeader(),
		});
	}

	async reenviarPendentes(unidadeDistribuidoraId) {
		return this.axios.put("whatsapp-distribuidor/reenviar-pendentes", { unidadeDistribuidoraId }, {
			headers: this.getAuthHeader(),
		});
	}

	async vincularColeta(mensagemId, coletaId) {
		return this.axios.put(`whatsapp-distribuidor/mensagem/${mensagemId}/vincular-coleta`, { coletaId }, {
			headers: this.getAuthHeader(),
		});
	}

	// Uma unidade pode ter varios agendamentos, cada um com sua janela de datas,
	// horario e selecao de fornecedores.
	async listarAgendamentos(unidadeDistribuidoraId) {
		return this.axios.get("whatsapp-distribuidor/agendamentos", {
			params: { unidadeDistribuidoraId },
			headers: this.getAuthHeader(),
		});
	}

	async criarAgendamento(data) {
		return this.axios.post("whatsapp-distribuidor/agendamentos", data, {
			headers: this.getAuthHeader(),
		});
	}

	async atualizarAgendamento(id, data) {
		return this.axios.put(`whatsapp-distribuidor/agendamentos/${id}`, data, {
			headers: this.getAuthHeader(),
		});
	}

	async excluirAgendamento(id) {
		return this.axios.delete(`whatsapp-distribuidor/agendamentos/${id}`, {
			headers: this.getAuthHeader(),
		});
	}
}

export default WhatsappRepository;
